/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartContainer_user$ref = any;
type CartContainer_viewer$ref = any;
export type CartRefetchContainer_viewer$ref = any;
export type CartRefetchContainer_viewer = {
    readonly user?: {
        readonly " $fragmentRefs": CartContainer_user$ref;
    } | null;
    readonly " $fragmentRefs": CartContainer_viewer$ref;
    readonly " $refType": CartRefetchContainer_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartRefetchContainer_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "userId",
            "type": "String!"
        },
        {
            "kind": "RootArgument",
            "name": "hasUserId",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "CartContainer_viewer",
            "args": null
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "userId",
                            "variableName": "userId"
                        }
                    ],
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "CartContainer_user",
                            "args": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '9cf6af01353fcfc28af8f31450dc77f8';
export default node;
